export default function MedalTallyCard({ results }) {
  const gold = results.filter(r => r.medal === "Gold").length;
  const silver = results.filter(r => r.medal === "Silver").length;
  const bronze = results.filter(r => r.medal === "Bronze").length;

  const rows = [
    { icon: "🥇", label: "Gold", count: gold },
    { icon: "🥈", label: "Silver", count: silver },
    { icon: "🥉", label: "Bronze", count: bronze },
  ];

  return (
    <div className="p-4 bg-white shadow rounded-xl">
      <h1 className="text-center">No. of Medals</h1>
      <div className="grid grid-cols-[80px_70px] justify-center gap-2 mt-2">
        {rows.map((r, i) => (
          <div key={i} className="contents">
            {/* Emoji + Label together */}
            <div className="flex items-center space-x-1 text-xl font-bold">
              <span>{r.icon}</span>
              <span>{r.label}</span>
            </div>
            {/* Number aligned right, bold */}
            <span className="text-right text-xl font-bold">{r.count}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
